import Head from "next/head";
import Container from "react-bootstrap/Container";
import Header from "@/components/Header";
import {Alert} from "react-bootstrap";

export default function Home() {
  return (
    <>
      <Head>
        <title>Bootstrap w/ React</title>
        <meta name="description" content="Generated by create next app" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Container as="main" className="py-4 px-3 mx-auto">
        <Header />
          <Alert variant="warning">Not implemented</Alert>
      </Container>
    </>
  );
}
